<template>
  <div class="navbar-item has-dropdown is-hoverable">
    <a class="navbar-link is-arrowless">
      <span class="tag" v-text="getNotifications.length" :class="[ getNotifications.length > 0 ? 'is-danger' : '' ]"></span>
      <small class="small-text">Notifications</small>
    </a>
    <div class="navbar-dropdown is-right">
      <template v-if="getNotifications.length  > 0">
        <div @click="navigate(item.type, item.project_id, item.origin_id, item.id)" class="navbar-item" v-for="(item, index) in getNotifications" :key="index">
          <p>
            <strong v-text="item.created_by"></strong> has create {{ item.type | type }} ref: <strong v-text="item.origin_reference"></strong> in project: {{ item.project_title }}
          </p>
          <div class="tags my_1">
            <span class="tag is-danger">Unread</span>
            <span class="tag">{{ item.created_at | fromNow }}</span>
          </div>
        </div>
      </template>
      <div class="navbar-item" v-else>
        <p>No record has been found.</p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
export default {
  computed: {
    ...mapGetters(['getNotifications']),
  },
  filters: {
    fromNow (value) {
      return moment(value).fromNow()
    },
    type (value) {
      let type
      if (value === 'App\\Models\\Expense') {
        type = 'expense'
      } else if (value === 'App\\Models\\Attendance') {
        type = 'attendance'
      }
      return type
    }
  },
  methods: {
    ...mapActions(['getNotificationsCollection', 'readNotifications']),
    navigate (type, project_id, type_id, id) {
      let typeIs = type === 'App\\Models\\Expense' ? 'expenses.reports' : 'attendances.labour'
      this.readNotifications(id)
      this.$router.push({
        name: `dashboard.projects.${typeIs}`,
        params: {
          id: project_id,
          report_id: type_id
        }
      })
    }
  },
  created () {
    this.getNotificationsCollection()
  }
}
</script>

<style lang="scss" scoped>
.tag {
  margin-right: 0.850rem;
}
.small-text {
  font-size: 0.750rem;
  font-weight: 600;
}
.navbar-dropdown {
  min-width: 480px;
  max-width: 480px;
  max-height: 480px;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  .navbar-item {
    cursor: pointer;
    display: inline-block;
    width: 100%;
    white-space: normal;
    word-break: break-all;
    border-bottom: solid 1px #ebebeb;
    transition: ease-in-out .3s;
    color: gray;
    padding: 1rem 1.5rem;
    &:hover {
      background-color: #fafafa;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
